var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
let BrandModel = class BrandModel {
    constructor() {
        this.id = -1;
        this.group_id = -1;
        this.name = "";
        this.external_business_name = undefined;
        this.type = "";
        this.services = [];
        this.is_scheduling_member = false;
        this.is_primary = false;
        this.is_archived = false;
        this.positions = [];
        this.timezoneName = "";
        this.employer_has_access = false;
    }
};
__decorate([
    JsonProperty("id", Number)
], BrandModel.prototype, "id", void 0);
__decorate([
    JsonProperty("group_id", Number, true)
], BrandModel.prototype, "group_id", void 0);
__decorate([
    JsonProperty("name", String)
], BrandModel.prototype, "name", void 0);
__decorate([
    JsonProperty("external_business_name", String, true)
], BrandModel.prototype, "external_business_name", void 0);
__decorate([
    JsonProperty("type", String)
], BrandModel.prototype, "type", void 0);
__decorate([
    JsonProperty("services", [String], true)
], BrandModel.prototype, "services", void 0);
__decorate([
    JsonProperty('is_scheduling_member', Boolean, true)
], BrandModel.prototype, "is_scheduling_member", void 0);
__decorate([
    JsonProperty('is_primary', Boolean, true)
], BrandModel.prototype, "is_primary", void 0);
__decorate([
    JsonProperty('is_archived', Boolean, true)
], BrandModel.prototype, "is_archived", void 0);
__decorate([
    JsonProperty('positions', [], true)
], BrandModel.prototype, "positions", void 0);
__decorate([
    JsonProperty('timezoneName', String, true)
], BrandModel.prototype, "timezoneName", void 0);
__decorate([
    JsonProperty('employer_has_access', Boolean, true)
], BrandModel.prototype, "employer_has_access", void 0);
BrandModel = __decorate([
    JsonObject("BrandModel")
], BrandModel);
export { BrandModel };
let BrandInfoModel = class BrandInfoModel {
    constructor() {
        this.id = -1;
        this.group_id = -1;
        this.name = "";
        this.phone = '';
        this.type = "";
        this.slug = '';
    }
};
__decorate([
    JsonProperty("group_id", Number)
], BrandInfoModel.prototype, "id", void 0);
__decorate([
    JsonProperty("group_id", Number, true)
], BrandInfoModel.prototype, "group_id", void 0);
__decorate([
    JsonProperty("name", String)
], BrandInfoModel.prototype, "name", void 0);
__decorate([
    JsonProperty("phone", String, true)
], BrandInfoModel.prototype, "phone", void 0);
__decorate([
    JsonProperty("type", String)
], BrandInfoModel.prototype, "type", void 0);
__decorate([
    JsonProperty("slug", String, true)
], BrandInfoModel.prototype, "slug", void 0);
BrandInfoModel = __decorate([
    JsonObject("BrandInfoModel")
], BrandInfoModel);
export { BrandInfoModel };
//# sourceMappingURL=brand.model.js.map